/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SessionIntent = {
    Fishing: 'fishing',
    Testing: 'testing',
    Unknown: 'unknown',
} as const;
export type SessionIntent = typeof SessionIntent[keyof typeof SessionIntent];


export function instanceOfSessionIntent(value: any): boolean {
    for (const key in SessionIntent) {
        if (Object.prototype.hasOwnProperty.call(SessionIntent, key)) {
            if (SessionIntent[key as keyof typeof SessionIntent] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SessionIntentFromJSON(json: any): SessionIntent {
    return SessionIntentFromJSONTyped(json, false);
}

export function SessionIntentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionIntent {
    return json as SessionIntent;
}

export function SessionIntentToJSON(value?: SessionIntent | null): any {
    return value as any;
}

export function SessionIntentToJSONTyped(value: any, ignoreDiscriminator: boolean): SessionIntent {
    return value as SessionIntent;
}

